if (process.env.NODE_ENV === 'development') {
  module.exports = require('./CurrentBreakpoint')
} else {
  module.exports = {
    CurrentBreakpoint: function () {
      return null
    },
  }
}
